var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDocBi(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "24/Archivo/Documento mas"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 2.75C5.20507 2.75 3.75 4.20507 3.75 6V18C3.75 19.7949 5.20507 21.25 7 21.25H12C12.4142 21.25 12.75 21.5858 12.75 22C12.75 22.4142 12.4142 22.75 12 22.75H7C4.37665 22.75 2.25 20.6234 2.25 18V6C2.25 3.37665 4.37665 1.25 7 1.25H13.0633C13.8794 1.25 14.6534 1.61251 15.1759 2.23949L19.1126 6.96359C19.5245 7.45781 19.75 8.08077 19.75 8.7241V12C19.75 12.4142 19.4142 12.75 19 12.75C18.5858 12.75 18.25 12.4142 18.25 12V8.7241C18.25 8.43168 18.1475 8.14851 17.9603 7.92387L14.0235 3.19977C13.786 2.91478 13.4342 2.75 13.0633 2.75H7Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.75 19C22.75 19.4142 22.4142 19.75 22 19.75H16C15.5858 19.75 15.25 19.4142 15.25 19C15.25 18.5858 15.5858 18.25 16 18.25H22C22.4142 18.25 22.75 18.5858 22.75 19Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 22.75C18.5858 22.75 18.25 22.4142 18.25 22V16C18.25 15.5858 18.5858 15.25 19 15.25C19.4142 15.25 19.75 15.5858 19.75 16V22C19.75 22.4142 19.4142 22.75 19 22.75Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 1.75C14.4142 1.75 14.75 2.08579 14.75 2.5V6C14.75 6.69036 15.3096 7.25 16 7.25H18.5C18.9142 7.25 19.25 7.58579 19.25 8C19.25 8.41421 18.9142 8.75 18.5 8.75H16C14.4812 8.75 13.25 7.51878 13.25 6V2.5C13.25 2.08579 13.5858 1.75 14 1.75Z",
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocBi);
export default __webpack_public_path__ + "static/media/DOC_BI.d45e6321a1afa881287b83f6228c83d2.svg";
export { ForwardRef as ReactComponent };